import { Injectable } from '@angular/core';
import { User, UserManager, UserManagerSettings } from 'oidc-client';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  userManager!: UserManager;
  user: User | null = null;

  private get idpSettings(): UserManagerSettings {
    return {
      authority: environment.sso_AUTH_URL,
      client_id: environment.sso_client_id,
      redirect_uri: environment.sso_redirect_uri,
      post_logout_redirect_uri: environment.sso_redirect_uri,
      response_type: 'code',
      scope: environment.sso_scope,
      filterProtocolClaims: true,
      loadUserInfo: true
    };
  }

  constructor( ) {
    this.userManager = new UserManager(this.idpSettings);
    this.userManager.getUser().then(user => {
      this.user = user;
    });
  }

  isLoggedIn(): boolean {
    return this.user != null && !this.user.expired;
  }

  startAuthentication(): Promise<void> {
    return this.userManager.signinRedirect().catch((err) => {
      console.log('startAuthentication in AuthService', 'Signin redirect error:' + err);  
    });
  }

  completeAuthentication(): Promise<void> {
    return this.userManager.signinRedirectCallback().then((user) => {
      this.user = user;
    });
  }

  getUser(): Promise<User | null> {
    return this.userManager.getUser();
  }

  renewToken(): Promise<User | null> {
    return this.userManager.signinSilent();
  }

}
